import classNames from 'classnames';
import React from 'react';
import './Tray.scss';
import ITrayProps from './TrayProps';

const Tray = ({ align, spacing, className, children }: ITrayProps) => {
  const classes = classNames(
    {
      tray: true,
      [`tray-align-${align}`]: true,
      [`tray-spacing-${spacing}`]: true,
    },
    className
  );

  return <div className={classes}>{children}</div>;
};

Tray.defaultProps = {
  align: 'left',
  spacing: 3,
};

export default Tray;
